import { compose } from 'redux';
import { FC } from 'react';
import {
  withStore,
  withSaga,
  withTheming,
  configTranslation,
  withRouter,
  injectReducer,
  injectSaga,
  configGrid,
  injectTranslations,
  configAnalytics,
} from 'ia-react-core';
import { Content } from '~/interfaces/Content';
import { isLocalhost } from '~/utils/urlUtils';
import { Analytics, Constants } from 'omni-package-react-analytics';
import { GetDealersExperience } from '~/utils/dealerUtils';
import App, { AppProps } from './App';
import appReducer from './App.reducer';
import appSage from './App.saga';
import fr from './translations/fr';
import en from './translations/en';

const initialState: Partial<Content> = {
  isLoaded: false,
};
const storeOptions = { initialState };
const unifiExperience = 'unifi';
const dealersExperience = GetDealersExperience() ?? unifiExperience;
const googleAnalyticsId = dealersExperience === unifiExperience ? Constants.IDs.iaDealer : Constants.IDs.iaDealerOEM;
const analyticsManager = new Analytics(googleAnalyticsId, {});
export default compose<FC<AppProps>>(
  withStore(storeOptions),
  withSaga,
  withTheming((dynamicTheme) => dynamicTheme),
  configTranslation({
    saveCookie: isLocalhost(),
    detection: {
      order: ['cookie', 'navigator'],
      lookupCookie: 'ee_language',
    },
  }),
  withRouter({
    basename: '/',
    router: 'hash',
  }),
  configGrid,
  injectReducer({
    key: 'content',
    reducer: appReducer,
    initialState: null,
    useScope: false,
    cleanState: true,
  }),
  injectSaga({
    key: 'content',
    saga: appSage,
  }),
  injectTranslations('App', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
  configAnalytics({
    managers: [
      analyticsManager,
    ],
  }),
)(App);
